<template>
  <div class="tf">
    <div class="tf__row">
      <el-switch
        :value="value"
        @change="$emit('input', $event)"
        :active-value="activeValue"
        :inactive-value="inactiveValue"
        :active-color="activeColor"
      />
      <label class="tf__label">{{ label }}</label>
    </div>
    <p v-if="hint" class="tf__hint">{{ hint }}</p>
  </div>
</template>

<script>
import { Switch } from 'element-ui';

/**
 * ToggleField
 * Standard el-switch + label + optional hint. Default activeValue/inactiveValue
 * are 1/0 to match the project's TINYINT(1) schema convention.
 *
 * @prop {Number|Boolean} value
 * @prop {String} label
 * @prop {String} hint            optional supporting copy
 * @prop {Number|Boolean} activeValue   default 1
 * @prop {Number|Boolean} inactiveValue default 0
 * @prop {String} activeColor     default OTC pink
 */
export default {
  name: 'ToggleField',
  components: { [Switch.name]: Switch },
  props: {
    value: { type: [Number, Boolean], required: true },
    label: { type: String, required: true },
    hint: { type: String, default: '' },
    activeValue: { type: [Number, Boolean], default: 1 },
    inactiveValue: { type: [Number, Boolean], default: 0 },
    activeColor: { type: String, default: '#e14eca' },
  },
};
</script>

<style lang="scss" scoped>
.tf {
  &__row {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  &__label {
    color: rgba(255, 255, 255, 0.95);
    font-size: 13px;
    line-height: 1.2;
    margin: 0;
  }

  &__hint {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.7);
    line-height: 1.45;
    margin: 4px 0 0 50px; // align past the switch
  }
}
</style>

<style>
.white-content .tf__label {
  color: rgba(0, 0, 0, 0.85);
}
.white-content .tf__hint {
  color: rgba(0, 0, 0, 0.6);
}
</style>
